import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Icon, Tooltip, Modal } from 'antd';
import axios from 'axios';

import { useGoogleLogin } from '@react-oauth/google';

import logo from '../../assets/images/logo-full-color.png';
import styles from './Login.module.scss';

const Login = ({
  isLoggedIn,
  isEmailValid,
  checkEmailValidity,
  userLogin,
  saveUserProfile,
  saveUserToken
}) => {
  const [newLogin, setNewLogin] = useState(true);

  const onLoginSuccess = async res => {
    if (res) {
      // Fetching `userinfo` from Google API.
      const userInfo = await axios
        .get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${res.access_token}` }
        })
        .then(res => res.data);

      setNewLogin(true);
      userLogin();

      if (res.hd && emailChecker(res.hd)) {
        saveUserProfile(userInfo);
        saveUserToken(res.access_token);
      }
    }
  };

  const onLoginFailure = res => {
    console.error(res);
  };

  const handleLogin = useGoogleLogin({
    onSuccess: onLoginSuccess,
    onError: onLoginFailure
  });

  const emailChecker = emailPrefix => {
    const expectedPrefix = 'tigergraph.com';
    const isMatched = emailPrefix === expectedPrefix;

    checkEmailValidity(isMatched);

    console.log(isMatched);

    return isMatched;
  };

  const loginPage = (
    <div className={styles.container}>
      {isLoggedIn && (
        <InvalidEmailModal newLogin={newLogin} shouldModalDisplayed={isLoggedIn && !isEmailValid} />
      )}

      <header className={styles.header}>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={logo} alt="logo" />
        </div>
      </header>
      <div className={styles.content}>
        <div className={styles.title}>
          <span className={styles.titleText}>License Tracker</span>
        </div>
        <div className={styles.loginButtonWrapper}>
          <Button
            className={styles.loginButton}
            type={'primary'}
            size={'large'}
            block={true}
            onClick={handleLogin}
          >
            Log In
          </Button>

          <Tooltip
            className="little-margin-left"
            title="Only allow email with @tigergraph.com suffix to login"
            placement={'right'}
          >
            <Icon className={styles.tooltipIcon} type="info-circle" />
          </Tooltip>
        </div>
      </div>
      <footer className={styles.footer}>
        Copyright (c) 2019 TigerGraph, Inc. All Rights Reserved.
      </footer>
    </div>
  );

  return isLoggedIn && isEmailValid ? <Redirect to={'/'} /> : loginPage;
};

const InvalidEmailModal = ({ newLogin, shouldModalDisplayed }) => {
  const [visible, setVisible] = useState(false);

  const handleClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    // Use `newLogin` to display modal again because `shouldModalDisplayed` is the same
    if (newLogin) {
      setVisible(shouldModalDisplayed);
    }
  }, [shouldModalDisplayed, newLogin]);

  return (
    <Modal
      visible={visible}
      title={'Invalid Email'}
      width={560}
      footer={null}
      onCancel={handleClose}
      destroyOnClose={true}
    >
      Your email is invalid. Please use the email with @tigergraph.com suffix to login.
    </Modal>
  );
};

export default Login;
